import { Text as DSText } from '@cinch-labs/design-system'

interface TextProps {
  body: string
}

export const Text: React.FC<TextProps> = ({ body }) => (
  <DSText element="p">{body}</DSText>
)
